/**
 * @fileoverview One click back in for a reader whose last sign-in was the
 * extension.
 *
 * AN EXTENSION SIGN-IN IS NOT RESTORED ON RELOAD, ON PURPOSE. Shared auth never
 * touches window.nostr during a page load, because reading it makes the
 * extension prompt, and a page load is not the reader asking for anything
 * (operator, 2026-08-25). So a share recipient who reloads is signed out, and
 * the way back has to be a click they make. The shared session says when to
 * offer it: the last method was the extension and one is installed.
 *
 * The extension is asked on the click and never on render.
 */

import { useNostrAuth } from '@cloistr/auth';
import { useSharedSessionMaybe } from '@cloistr/ui/components';

export function ContinueWithExtension() {
  const auth = useNostrAuth();
  const offer = useSharedSessionMaybe()?.offerExtension ?? false;

  if (!offer || auth.authState.pubkey) return null;

  return (
    <p className="continue-extension">
      <button
        type="button"
        className="continue-extension-button"
        onClick={() => {
          // A refused or dismissed prompt leaves the reader where they were;
          // the auth state already says why, so there is nothing to add here.
          auth.connectNip07().catch(() => undefined);
        }}
      >
        Continue with extension
      </button>
    </p>
  );
}
